











import InputField from "./InputField";

export default {
    name: "PasswordInput",
    components: { InputField },
    props: {
        label: String,
        value: String,
    },
    data() {
        return {
            editString: "",
        };
    },
    watch: {
        value: {
            immediate: true,
            handler: function () {
                this.editString = this.value;
            },
        },
        editString: function () {
            this.$emit("input", this.editString);
        },
    },
};
